import React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

import MobileFileServer from "components/MobileFileServer";
import PublicLayout from "layouts/Public";

const App = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/Default.aspx" render={() => window.location.href = "/"} />
                <Route path="/wcf/*" render={() => window.location.href = "/wcf"} />
                <Route path="/FileServer.aspx/*" render={() => window.location.href = "/FileServer.aspx"} />
                {/* <Route path="/FileServer.aspx" render={(props) => <MobileFileServer {...props} />} /> */}
                <Route path="/" render={(props) => <PublicLayout {...props} />} />
            </Switch>
        </BrowserRouter>
    );
};

function mapStateToProps(state) {
    const { account, terms } = state;
    return {
        account,
        terms,
    };
};

export default connect(mapStateToProps)(App);